export const SENTRY_INTAKE_SEED_SIZE = 10;

export const SENTRY_INTAKE_SETUP_COPY = {
  pageTitle: "How should Sentry issues become tasks?",
  setupButton: "Setup Sentry",
  wizardBackToBoard: "Back to board",
  wizardBack: "Back",
  wizardStepConnect: "Connect Sentry",
  wizardStepConnectHelper: "Install the SuperPlane Sentry app so SuperPlane can read issues and listen for new ones.",
  wizardStepConnectExisting: "Choose the Sentry organization that SuperPlane will monitor.",
  wizardStepProject: "Which Sentry project should create tasks?",
  wizardStepProjectHelper:
    "SuperPlane adds the 10 newest unresolved issues of this project. SuperPlane also listens for new issues.",
  wizardConnect: "Connect Sentry",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardPreviewLabel: "Example Sentry issues",
  wizardPreviewHeading: "Unresolved issues",
  wizardPreviewImporting: "Importing...",
  wizardPreviewListening: "New issues become tasks.",
  wizardPreviewCaption: "SuperPlane adds the 10 newest unresolved issues. New issues become tasks.",
  wizardPreviewCaptionNoProject: "Select a project to import 10 unresolved issues and listen for new ones.",
  wizardProjectsLoading: "Loading Sentry projects...",
  wizardProjectsError: "SuperPlane could not load Sentry projects.",
  wizardIssuesError: "SuperPlane could not load unresolved issues for this project.",
  wizardProjectsEmpty: "This connection has no available projects.",
  wizardRetry: "Try again",
  wizardConnectError: "SuperPlane could not open the Sentry install page.",
  wizardCreateError: "SuperPlane could not create the Sentry intake.",
  exampleIssues: [
    "TypeError: Cannot read properties of undefined",
    "Timeout on checkout payment intent",
    "Null pointer in invoice serializer",
    "429 from the billing provider",
    "Unhandled promise in webhook worker",
    "Missing CSRF token on settings save",
    "Deadlock on inventory reservation",
    "JWT expired during token refresh",
    "Redis connection reset by peer",
    "Duplicate key on user email index",
  ],
} as const;
